import { findLastKey } from 'lodash';
import { ROUTES } from 'constants/routes';

const routerPattern = (path) => path.replace(/\//g, '\\/', true)
  .replace(':uuid?', '.*')
  .replace(':id', '.*');

export const getRouteKeyFromPath = (path) =>
  findLastKey(ROUTES, (o) => !!path.match(new RegExp(routerPattern(o))));
